export type HelperMeCard = 'QUOTA' | 'RELIABILITY' | 'BLOCKERS'

export const computeHelperMeInsight = (args: {
  card: HelperMeCard
  quota?: { enabled: boolean; percentComplete?: number; unit?: string; error?: boolean }
  reliability?: { completedCount: number; vouchCount: number }
  blockers?: { openCount: number }
}): string => {
  if (args.card === 'QUOTA') {
    if (!args.quota?.enabled) return 'Quota is off for this workspace.'
    if (args.quota.error) return 'Trend and quota load will resume shortly.'
    const percent = Math.round(args.quota.percentComplete ?? 0)
    return percent === 0 ? 'No progress logged for today yet.' : `You're at ${percent}% of today's quota.`
  }
  if (args.card === 'RELIABILITY') {
    const completed = args.reliability?.completedCount ?? 0
    const vouches = args.reliability?.vouchCount ?? 0
    if (completed < 5) {
      const remaining = 5 - completed
      return `${remaining} ${remaining === 1 ? 'task' : 'tasks'} to unlock your reliability score.`
    }
    return `${completed} completed · ${vouches} ${vouches === 1 ? 'vouch' : 'vouches'} this window.`
  }
  const open = args.blockers?.openCount ?? 0
  if (open === 0) return 'No open blockers today.'
  return `${open} ${open === 1 ? 'blocker' : 'blockers'} waiting on you.`
}
